import {registerPortalRoot} from '@primer/react'
import {useRef, useEffect} from 'react'

/**
 *
 * @param param0 - The name of the portal to register.
 * This is used to create a container for the overlay portal.
 * The container will be registered with the specified portal name.
 *
 * This is useful if you have a component that needs to render the overlay portal
 * in a specific location in the DOM in order to attach the overlay to a specific part of the UI.
 *
 * For example, the ReviewMenuButton uses this to register the portal root for the review menu.
 * This lets the ReviewMenu overlay "pin" to the button while it scrolls - even when the button is in the sticky header.
 *
 * @example
 * <OverlayPortalContainer portalName="my-portal" />
 */
export const OverlayPortalContainer = ({portalName}: {portalName: string}) => {
  const portalContainer = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (portalContainer.current) {
      registerPortalRoot(portalContainer.current, portalName)
    }
  }, [portalName])

  return <div ref={portalContainer} className="position-absolute" />
}
